import { haveSameElements } from "app/pages/sales-intelligence/utils/arrays";
import { buildInclusionConditionKey } from "app/pages/sales-intelligence/utils/inclusionConditionKey";

import type { IIndustryCodesFilterDto } from "../types/filter-values";

export const getIndustryCodesConditionKey = (item: IIndustryCodesFilterDto): string =>
    buildInclusionConditionKey(item.inclusion, item.sicCodes, item.naicsCodes);

export const hasSameIndustryCodesObject = (
    item: IIndustryCodesFilterDto,
    comparedItem: IIndustryCodesFilterDto | null,
): boolean => {
    if (comparedItem === null) {
        return false;
    }

    return (
        item.inclusion === comparedItem.inclusion &&
        haveSameElements(item.sicCodes, comparedItem.sicCodes) &&
        haveSameElements(item.naicsCodes, comparedItem.naicsCodes)
    );
};
